import { useContext } from 'react'
import { AuthContext } from '../auth'
import { Role } from '../auth/auth-context'

export const useAuthentication = () => {
  const { authentication } = useContext(AuthContext)
  return { isAuthenticated: !!authentication?.token, isAdmin: authentication?.role === Role.ADMIN }
}
